export enum FilterScope {
  RecentlyViewed = 'recently_viewed',
  EnrolledInArchival = 'enrolled_in_archival',
  ApprovalTypes = 'approval_types',
  Authority = 'authority',
  AssetTypes = 'asset_types',
  Source = 'source',
  Version = 'version',
  Visibility = 'visibility',
}

export const getScope = (scope: FilterScope): string => {
  return `shared.asset_browser.filters.${scope}`;
};
